import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { Box, Card } from "@mui/material";
import React, { useEffect, useState } from "react";

import TabPanel from "../../helpers/TabPanel";
import LeaveTypeComponent from "../../components/Settings/LeaveType";
import MeetingTypeComponent from "../../components/Settings/MeetingType";
import MyStructureSettings from "./Structure/MyStructureSettings";
import StructureMenu from "./Structure/StructureMenu";
import SystemUsers from "./Structure/SystemUsers";
import TabBoxComponent from "components/UI/TabBox";
import Holidays from "../../components/Settings/Holidays";
import ApprovalProcessComponent from "../../components/Settings/ApprovalProcess";

const SystemPermission = ({
  location,
  SetSelectedMenu,
  structures,
  GetMyStructure,
  loggedUser,
  PutAction,
  wholeStructure,
  FetchDetails,
}) => {
  const [tabValue, setTabValue] = useState(location?.state?.tab ?? 0);
  const [positions, setPositions] = useState([]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    const fetchPositions = async () => {
      try {
        const response = await FetchDetails("/api/staff-position/viewAll");
        if (response?.status) {
          setPositions(response?.data?.list || []);
        }
      } catch (error) {
        console.error("Error fetching positions:", error);
      }
    };
    fetchPositions();
  }, [FetchDetails]);

  useEffect(() => {}, [wholeStructure]);

  return (
    <Card>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          "& .MuiTabs-root": {
            minHeight: "48px",
          },
          "& .MuiTabs-scroller": {
            overflowX: "auto !important",
            scrollbarWidth: "thin",
            "&::-webkit-scrollbar": {
              height: "6px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "3px",
            },
          },
        }}
      >
        <TabBoxComponent
          selectedValue={tabValue}
          handleTabChange={handleChange}
          sx={{
            maxWidth: "100%",
            "& .MuiTabs-flexContainer": {
              flexWrap: "nowrap",
            },
          }}
          variant="scrollable"
          scrollButtons="auto"
          tabList={[
            {
              label: "Menus",
              tabValue: 0,
            },
            {
              label: "General Actions",
              tabValue: 1,
            },
            {
              label: "Structure",
              tabValue: 2,
            },
            {
              label: "System Users",
              tabValue: 3,
            },
            {
              label: "Leave Type",
              tabValue: 4,
            },
            {
              label: "Public Holidays",
              tabValue: 5,
            },
            {
              label: "Meeting Type",
              tabValue: 6,
            },
            {
              label: "Approval Process",
              tabValue: 7,
            },
          ]}
        />
        <TabPanel index={0} value={tabValue} p={0}>
          <StructureMenu
            location={location}
            SetSelectedMenu={SetSelectedMenu}
            category={"menu"}
          />
        </TabPanel>
        <TabPanel index={1} value={tabValue} p={0}>
          <StructureMenu
            location={location}
            SetSelectedMenu={SetSelectedMenu}
            category={"action"}
          />
        </TabPanel>
        <TabPanel index={2} value={tabValue} p={0}>
          <MyStructureSettings
            structures={wholeStructure}
            GetMyStructure={GetMyStructure}
            loggedUser={loggedUser}
            wholeStructure={wholeStructure}
          />
        </TabPanel>
        <TabPanel index={3} value={tabValue} p={0}>
          <SystemUsers
            PutAction={PutAction}
            url={`/api/structure/user/dataTable`}
          />
        </TabPanel>

        <TabPanel index={4} value={tabValue} p={0}>
          <LeaveTypeComponent
            location={location}
            SetSelectedMenu={SetSelectedMenu}
            loggedUser={null}
          />
        </TabPanel>
        <TabPanel index={6} value={tabValue} p={0}>
          <MeetingTypeComponent
            location={location}
            SetSelectedMenu={SetSelectedMenu}
            loggedUser={null}
          />
        </TabPanel>
        <TabPanel index={5} value={tabValue} p={0}>
          <Holidays
            location={location}
            SetSelectedMenu={SetSelectedMenu}
            loggedUser={null}
          />
        </TabPanel>
        <TabPanel index={7} value={tabValue} p={0}>
          <ApprovalProcessComponent positions={positions} />
        </TabPanel>
      </Box>
    </Card>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemPermission);
